/**
 * §4.2 from the beheerder's side: a korps's ploegen, entered and changed namens that korps.
 * One dialog rather than the Aanmeldsite's two steps: a beheerder corrects one thing.
 */
export const ploegen = {
  korpsen: {
    label: "Korpsen",
    korps: "Korps",
    plaats: "Plaats",
    zoek: "Zoek een korps",
    leeg: "Je mag voor geen enkel korps handelen.",
    filterReedsIngeschreven: "Al ingeschreven",
    filterReedsIngeschrevenVerbergen: "Verbergen",
    filterReedsIngeschrevenAlleen: "Alleen ingeschreven tonen",
  },

  detail: {
    /** Namens handelen is visible while it is happening, as on the ondersteuners screen. */
    namens:
      "Je handelt <strong>namens {{korps}}</strong>. Alles wat je hier wijzigt, wordt vastgelegd op jouw naam, namens dit korps.",
    geenPeriode:
      "Dit seizoen heeft nog geen inschrijfperiode voor korpsen. Richt er eerst een in.",
    vensterOverrule:
      "{{venster}} Je handelt hier namens {{korps}}, dus je kunt alsnog wijzigen. De wijziging wordt vastgelegd op jouw naam, namens dit korps.",
  },

  lijst: {
    label: "Ploegen",
    ploeg: "Ploeg",
    filterKlasse: "Klasse",
    voorkeursdatums: "Voorkeursdatums",
    geenKlasse: "Nog geen klasse",
    geenVoorkeuren: "Nog niets ingevuld",
    leeg: "Dit korps heeft nog geen ploegen ingeschreven voor deze inschrijfperiode.",
    kiesPloeg:
      "Kies een ploeg om de klassen en voorkeursdatums te wijzigen of de inschrijving in te trekken.",
    voorkeurKort: "{{rang}}e {{datum}}",
    geenVoorkeurKort: "liever niet {{datum}}",
    onbekendeDag: "?",
  },

  nieuw: {
    trigger: "Ploeg inschrijven",
    title: "Ploeg inschrijven",
    description: "Voor {{korps}}, op {{periode}}.",
    submit: "Inschrijven",
  },

  wijzig: {
    description:
      "Deze ploeg staat ingeschreven. Wijzig de ploeg zo vaak je wilt zolang de inschrijving open is. Wat er staat als de inschrijfperiode sluit, is wat de wedstrijdleiders inplannen.",
    intrekken: "Ploeg intrekken",
    intrekkenVraag: "{{naam}} intrekken?",
    intrekkenDescription:
      "De klassen en voorkeursdatums van deze ploeg verdwijnen ook. Je kunt het intrekken niet ongedaan maken. Daarna kun je wel een nieuwe ploeg inschrijven.",
    intrekkenConfirm: "{{naam}} intrekken",
  },

  velden: {
    /** Worded exactly as the Aanmeldsite words it: a beheerder fills in the korps's own form. */
    samen: {
      label: "Samen met andere ploegen van jouw korps",
      description:
        "Zet dit aan als deze ploeg liever op dezelfde wedstrijddag speelt als de andere ploegen van je korps. JBNL houdt hier rekening mee, maar kan het niet garanderen.",
    },
    /** Worded exactly as the Aanmeldsite words it (ADR-0077). */
    vr: {
      label: "Komt met een gedeeld VR-voertuig",
      description:
        "Zet dit aan als deze ploeg komt met een voertuig van de veiligheidsregio dat ook andere ploegen gebruiken. JBNL plant dan tijd tussen de wedstrijden van deze ploegen, maar kan dat niet garanderen.",
    },
    naam: "Naam van de ploeg",
    naamUitleg:
      "Laat dit leeg voor <strong>{{standaard}}</strong>. Is die naam al bezet in een van de gekozen klassen? Dan komt er een nummer achter. Je kunt de naam later nog wijzigen.",
    klassen: "Klassen",
    klassenUitleg:
      "Kies de klassen waarvoor deze ploeg meedoet. Heeft je korps meerdere teams? Schrijf die in als aparte ploegen. Dan krijgt elk team een eigen naam.",
    /** The klasse leads: it tells two otherwise identical tables apart, also in a screen reader. */
    voorkeurenKlasse: "Voorkeursdatums {{klasse}}",
    sorteerOp: "Sorteer op",
    sorteerDatum: "Datum",
    sorteerReistijd: "Reistijd",
    kolomDag: "Wedstrijddag",
    kolomReistijd: "Reistijd",
    kolomVoorkeur: "Voorkeur",
    kolomGeenVoorkeur: "Liever niet",
    badgeVoorkeur: "{{rang}}e voorkeur",
    badgeGeenVoorkeur: "Liever niet",
    // The klasse is in both labels: the same date appears in every table on this page, so
    // without it a screen reader announces the same checkbox name two or three times.
    vinkVoorkeur: "Voorkeur voor {{datum}} in {{klasse}}",
    vinkGeenVoorkeur: "Liever niet op {{datum}} in {{klasse}}",
    dagRegel: "{{niveau}} · {{korps}} · {{klassen}}",
    geenKlassenOpDag: "geen klassen van deze inschrijving",
    geenDagen:
      "Er is dit seizoen geen enkele wedstrijddag waarop {{klasse}} wordt gespeeld. Kies hierboven een andere klasse.",
    /** Split in two: the maxima are per inschrijfperiode, so each count needs its own plural. */
    voorkeurenUitleg:
      "{{regels}} Vink je bij een dag niets aan? Dan is die dag gewoon mogelijk. Je ziet per klasse alleen de dagen waarop die klasse wordt gespeeld. De reistijd is een schatting van de rijtijd met de auto vanaf je korps.",
    regelVoorkeur_one: "Kruis per klasse hoogstens één dag aan als voorkeur.",
    regelVoorkeur_other:
      "Kruis per klasse hoogstens {{count}} dagen aan als voorkeur. De eerste die je aankruist, is je eerste voorkeur.",
    regelGeenVoorkeur_one:
      "Kruis hoogstens één dag aan bij Liever niet: de dag die voor je korps echt niet uitkomt.",
    regelGeenVoorkeur_other:
      "Kruis hoogstens {{count}} dagen aan bij Liever niet: de dagen die voor je korps echt niet uitkomen.",
  },

  /** A rounded drive, never the seconds the planner sorts on. */
  reistijd: {
    onbekend: "Onbekend",
    minuten: "± {{minuten}} min",
    uren: "± {{uren}} uur",
    urenMinuten: "± {{uren}} uur {{minuten}} min",
  },

  errors: {
    periodesOphalen: "Kon de inschrijfperiodes niet ophalen.",
    ophalen: "Kon de inschrijving niet ophalen.",
    inschrijven: "Kon de ploeg niet inschrijven.",
    opslaan: "Kon de inschrijving niet opslaan.",
    intrekken: "Kon de ploeg niet intrekken.",
  },
} as const;
